"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberRoleDropDown = void 0;
const react_1 = __importStar(require("react"));
const common_1 = require("../../../../../common");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
// 참여 권한 선택
const liveModeList = [
    { id: 'admin', title: 'conference.admin' },
    { id: 'host', title: 'conference.host' },
    { id: 'manager', title: 'conference.manager' },
    { id: 'participant', title: 'conference.participant' },
];
const default_mode = { id: 'participant', title: 'conference.participant' };
exports.MemberRoleDropDown = react_1.default.memo(({ isDisable = false, defaultRole, handlerUpdateOption, }) => {
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [dropValue, setDropValue] = react_1.default.useState(default_mode);
    (0, react_1.useEffect)(() => {
        // defaultRole이 변경될 때만 dropValue를 설정
        const drop_item = liveModeList.find(item => item.id === defaultRole) || default_mode;
        setDropValue(drop_item);
    }, [defaultRole]);
    (0, react_1.useEffect)(() => {
        // dropValue가 defaultRole과 다른 경우에만 handlerUpdateOption을 호출
        if (dropValue.id !== defaultRole) {
            handlerUpdateOption(dropValue);
        }
    }, [dropValue, defaultRole, handlerUpdateOption]);
    return (react_1.default.createElement(common_1.DropDown, { isDisable: isDisable, className: `${isMobile ? 'dropdown-mini' : 'dropdown-live'} ${isDisable ? 'disable' : ''}`, value: dropValue, list: liveModeList, option: {
            downIcon: {
                show: !isDisable,
            },
        }, setDropValue: setDropValue }));
});
